import { supabase } from '../lib/supabase'

export interface Comune {
  nome: string
  provincia: string
}

/** Ricerca per prefisso del nome. Sotto i due caratteri non ha senso interrogare. */
export async function cercaComuni(testo: string): Promise<Comune[]> {
  if (testo.trim().length < 2) return []
  const { data, error } = await supabase
    .from('comune')
    .select('nome, provincia')
    .ilike('nome', `${testo}%`)
    .order('nome')
    .limit(20)
  if (error) throw new Error(error.message)
  return (data ?? []) as Comune[]
}
